import styled from '@emotion/styled';
import { KizenTypography } from 'app/typography';
import { IconWithTooltip } from './IconWithTooltip';

const LinkWrapper = styled.div`
  display: flex;
  align-items: center;

  i {
    margin-left: 5px;
  }
`;

export const LinkWithIconTooltip = ({
  children,
  href,
  label,
  dataQA = 'link-with-icon-tooltip',
  ...iconProps
}) => {
  return (
    <LinkWrapper>
      <KizenTypography
        type="anchor"
        target="_blank"
        href={href}
        data-qa={dataQA}
      >
        {children}
      </KizenTypography>
      <IconWithTooltip label={label} {...iconProps} />
    </LinkWrapper>
  );
};
